import { createQueryKeys } from "@lukemorales/query-key-factory";

import type { CoreApiClient } from "../client";
import type { GetGeocodingAddressResponseBody, GetGeocodingReverseResponseBody } from "../types";

export const createGeocodingQueries = (api: CoreApiClient) => {
  const { client } = api;

  const search = async (address: string): Promise<GetGeocodingAddressResponseBody> => {
    const { data, error } = await client.GET("/geocoding/address", {
      params: { query: { location: address } },
    });
    if (error) throw new Error(error.message);
    return data;
  };

  const reverse = async (latitude: number, longitude: number): Promise<GetGeocodingReverseResponseBody> => {
    const { data, error } = await client.GET("/geocoding/reverse", {
      params: { query: { location: `${latitude},${longitude}` } },
      parseAs: "text",
    });
    if (error) throw new Error(error.message);
    return data;
  };

  return {
    search,
    reverse,
    queries: createQueryKeys("geocoding", {
      address: (address: string) => ({
        queryKey: [address],
        queryFn: () => search(address),
      }),
      reverse: (latitude: number, longitude: number) => ({
        queryKey: [latitude, longitude],
        queryFn: () => reverse(latitude, longitude),
      }),
    }),
  };
};
